import React from "react";

function AccordionData({ step, iron, title, options, number, shotOpction, defaultSelected }) {

    return (
        <>
            <div className="accordion-card-data">
                <div className="sec-header-dash club-fitting-card-header">
                    <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                        <h3 className="box-title-lable">
                            <span className="color">{number}</span> {title}
                        </h3>
                    </div>
                </div>
                <div className={`form-box-color custom-select-container  p-0 pt-3`}>
                    <label className="dashboard-form-lable new_clup_lable">Shot 1</label>
                    <div className="custom-form-group new_club_form_group">
                        <label className="dashboard-form-lable"> Strike</label>
                        <div className="w-60">
                            <div className='drop-down-wrapper d-flex gap-3'>
                                <div className={`custom-select-wrapper w-50`}>
                                    <div className={`selected-option clup_selected_option selected`}>
                                        <div className="custom-option-label2">
                                            <span className="option-text">{defaultSelected?.[step]?.[iron]?.shot1?.optionx ?? 1}</span>
                                            
                                        </div>
                                    </div>
                                </div>
                                <div className={`custom-select-wrapper w-50 `} >
                                    <div className={`selected-option clup_selected_option selected`}>
                                        <div className="custom-option-label2">
                                            <span className="option-text">{defaultSelected?.[step]?.[iron]?.shot1?.optiony ?? 1}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="custom-form-group new_club_form_group">
                        <label className="dashboard-form-lable"> Shape</label>
                        <div className="w-60">
                            <div className={`custom-select-wrapper w-100`}>
                                <div
                                    className={`selected-option clup_selected_option selected`}
                                >
                                    <div className="custom-option-label2">
                                        <span className="option-text">
                                        {defaultSelected && defaultSelected[step] && defaultSelected[step][iron] && defaultSelected[step][iron].shot1 && defaultSelected[step][iron].shot1.option1 ? defaultSelected[step][iron].shot1.option1 : 'Shot Shape'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="custom-form-group new_club_form_group">
                        <label className="dashboard-form-lable"> Result</label>
                        <div className="w-60">
                            <div className={`custom-select-wrapper w-100`}>
                                <div
                                    className={`selected-option clup_selected_option selected`}
                                >
                                    <div className="custom-option-label2">
                                        <span className="option-text">
                                        {defaultSelected && defaultSelected[step] && defaultSelected[step][iron] && defaultSelected[step][iron].shot1 && defaultSelected[step][iron].shot1.option2 ? defaultSelected[step][iron].shot1.option2 : 'Shot Result'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`form-box-color custom-select-container  p-0 pt-3`}>
                    <label className="dashboard-form-lable new_clup_lable">Shot 2</label>
                    <div className="custom-form-group new_club_form_group">
                        <label className="dashboard-form-lable"> Strike</label>
                        <div className="w-60">
                            <div className='drop-down-wrapper d-flex gap-3'>
                                <div className={`custom-select-wrapper w-50`}>
                                    <div className={`selected-option clup_selected_option selected`}>
                                        <div className="custom-option-label2">
                                            <span className="option-text">{defaultSelected?.[step]?.[iron]?.shot2?.optionx ?? 1}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className={`custom-select-wrapper w-50 `} >
                                    <div className={`selected-option clup_selected_option selected`}>
                                        <div className="custom-option-label2">
                                            <span className="option-text">{defaultSelected?.[step]?.[iron]?.shot2?.optiony ?? 1}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="custom-form-group new_club_form_group">
                        <label className="dashboard-form-lable"> Shape</label>
                        <div className="w-60">
                            <div className={`custom-select-wrapper w-100`}>
                                <div
                                    className={`selected-option clup_selected_option selected`}
                                >
                                    <div className="custom-option-label2">
                                        <span className="option-text">
                                        {defaultSelected && defaultSelected[step] && defaultSelected[step][iron] && defaultSelected[step][iron].shot2 && defaultSelected[step][iron].shot2.option1 ? defaultSelected[step][iron].shot2.option1 : 'Shot Shape'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="custom-form-group new_club_form_group">
                        <label className="dashboard-form-lable"> Result</label>
                        <div className="w-60">
                            <div className={`custom-select-wrapper w-100`}>
                                <div
                                    className={`selected-option clup_selected_option selected`}
                                >
                                    <div className="custom-option-label2">
                                        <span className="option-text">
                                        {defaultSelected && defaultSelected[step] && defaultSelected[step][iron] && defaultSelected[step][iron].shot2 && defaultSelected[step][iron].shot2.option2 ? defaultSelected[step][iron].shot2.option2 : 'Shot Result'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`form-box-color custom-select-container  p-0 pt-3`}>
                    <label className="dashboard-form-lable new_clup_lable">Shot 3</label>
                    <div className="custom-form-group new_club_form_group">
                        <label className="dashboard-form-lable"> Strike</label>
                        <div className="w-60">
                            <div className='drop-down-wrapper d-flex gap-3'>
                                <div className={`custom-select-wrapper w-50`}>
                                    <div className={`selected-option clup_selected_option selected`}>
                                        <div className="custom-option-label2">
                                            <span className="option-text">{defaultSelected?.[step]?.[iron]?.shot3?.optionx ?? 1}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className={`custom-select-wrapper w-50 `} >
                                    <div className={`selected-option clup_selected_option selected`}>
                                        <div className="custom-option-label2">
                                            <span className="option-text">{defaultSelected?.[step]?.[iron]?.shot3?.optiony ?? 1}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="custom-form-group new_club_form_group">
                        <label className="dashboard-form-lable"> Shape</label>
                        <div className="w-60">
                            <div className={`custom-select-wrapper w-100`}>
                                <div
                                    className={`selected-option clup_selected_option selected`}
                                >
                                    <div className="custom-option-label2">
                                        <span className="option-text">
                                        {defaultSelected && defaultSelected[step] && defaultSelected[step][iron] && defaultSelected[step][iron].shot3 && defaultSelected[step][iron].shot3.option1 ? defaultSelected[step][iron].shot3.option1 : 'Shot Shape'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="custom-form-group new_club_form_group">
                        <label className="dashboard-form-lable"> Result</label>
                        <div className="w-60">
                            <div className={`custom-select-wrapper w-100`}>
                                <div
                                    className={`selected-option clup_selected_option selected`}
                                >
                                    <div className="custom-option-label2">
                                        <span className="option-text">
                                        {defaultSelected && defaultSelected[step] && defaultSelected[step][iron] && defaultSelected[step][iron].shot3 && defaultSelected[step][iron].shot3.option2 ? defaultSelected[step][iron].shot3.option2 : 'Shot Result'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AccordionData;